import { render, staticRenderFns } from "./CertificateEditor.vue?vue&type=template&id=dc38d7e2&scoped=true"
import script from "./CertificateEditor.vue?vue&type=script&lang=js"
export * from "./CertificateEditor.vue?vue&type=script&lang=js"
import style0 from "./CertificateEditor.vue?vue&type=style&index=0&id=dc38d7e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc38d7e2",
  null
  
)

export default component.exports